<script>
export default {
  name: 'FavoriteReports',
  data() {
    return {
      reportsFilter: '',
      reports: [],
      reportFields: [
        {
          key: 'favName',
          label: 'Favorite Name',
          sortable: true
        },
        {
          key: 'metricsDashReportByReportName',
          label: 'Category',
          sortable: true,
          formatter: (value, key, item) =>
            item.metricsDashReportByReportName.categoryName
        },
        {
          key: 'reportName',
          sortable: true
        },
        'open',
        'delete'
      ]
    }
  },
  methods: {
    loadReports() {
      this.graphql(
        /* GraphQL */ `
          query lookupOptions_ReportFavoriteLookup {
            allMetricsDashFavs(orderBy: FAV_NAME_ASC) {
              nodes {
                reportName
                favName
                favOptions
                metricsDashReportByReportName {
                  categoryName
                }
              }
            }
          }
        `
      ).then(data => {
        this.reports = data.allMetricsDashFavs.nodes
      })
    },
    loadReport(report) {
      this.$router.push({
        name: 'Report',
        params: {
          name: report.reportName
        },
        query: {
          filters: report.favOptions
            ? JSON.stringify(report.favOptions.filters)
            : null,
          chartType: report.favOptions ? report.favOptions.chartType : null,
          run: 'true'
        }
      })
    },
    deleteFavorite(favorite) {
      this.$bvModal
        .msgBoxConfirm('Are you sure you would like to delete this favorite?', {
          title: 'Please Confirm',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            this.graphql(
              /* GraphQL */ `
                mutation deleteFavoriteMutation(
                  $personId: Int!
                  $favName: String!
                ) {
                  deleteMetricsDashFavByPersonIdAndFavName(
                    input: { personId: $personId, favName: $favName }
                  ) {
                    clientMutationId
                  }
                }
              `,
              {
                personId: this.$store.state.personId,
                favName: favorite.favName
              }
            ).then(() => {
              this.loadReports()
            })
          }
        })
    }
  },
  mounted() {
    this.loadReports()
  }
}
</script>

<template>
  <div>
    <b-row class="w-100">
      <b-col>
        <b-form-group
          label-cols-lg="1"
          label-for="reportsFilter"
          class="form-field-group"
          label-class="font-weight-bold pb-0"
          label="Filter"
        >
          <b-input-group>
            <b-form-input
              v-model="reportsFilter"
              name="reportsFilter"
              autocomplete="off"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <hr />
    <b-table
      striped
      hover
      :fields="reportFields"
      :items="reports"
      :filter="reportsFilter"
    >
      <template v-slot:cell(open)="data">
        <a
          href="javascript:{}"
          class="item-edit-icon-wrapper"
          @click="loadReport(data.item)"
        >
          <font-awesome-icon class="item-edit-icon" icon="arrow-circle-right" />
        </a>
      </template>
      <template v-slot:cell(delete)="data">
        <a
          href="javascript:{}"
          class="item-remove-icon-wrapper"
          @click="deleteFavorite(data.item)"
        >
          <font-awesome-icon class="item-remove-icon" icon="times-circle" />
        </a>
      </template>
    </b-table>
  </div>
</template>
